
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { Box } from '@mui/joy';
import { MdKeyboardArrowLeft } from 'react-icons/md';
import Image from 'next/image';
import Chip from '@mui/joy/Chip';
import dynamic from 'next/dynamic';
import { getApolloClient } from '../../../../utilities/apolloClient';
import { Article, Divider, Flex, SEO, Section } from '../../../../components';
import { Heading, Text } from '../../../../components/Text';
import { DefaultLayout } from '../../../../layouts';
import { getPostBySlug } from '../../../../queries/posts';
import { formatDate } from '../../../../utilities/format';
import { getNextStaticProps } from '../../../../utilities/getNextStaticProps';
// import ShareSocials from '../../../../components/Sections/Article/ShareSocials'
const ShareSocials = dynamic(() => import('../../../../components/Sections/Article/ShareSocials'), {
    ssr: false
});
export default function Page({ post }) {
    const author = post?.author?.node;
    return (<>
            <SEO fullHead={post?.seo?.fullHead} title={post?.seo?.title}/>
            <Section py={10}>
                <Flex alignItems="center">
                    <MdKeyboardArrowLeft />
                    <Text pl={1} component="a" href="/resources/blog" fontSize="1rem" rel="prefetch">
                        Back to All Blog Posts
                    </Text>
                </Flex>

                <Divider my={8}/>
                <Heading pb={0}>{post?.title}</Heading>
                <Flex mb={2}>
                    {post?.categories?.nodes?.map((category) => (<Chip>{category?.name}</Chip>))}
                </Flex>
                <Text mb={4} fontWeight={300}>
                    {formatDate(post?.date)} | Author: {author?.name}
                </Text>
                <Box position="relative" width="100%">
                    <Image quality={80} 
    // fill
    src={post?.featuredImage?.node?.sourceUrl} width={0} height={0} sizes="100vw" style={{ width: '100%', height: 'auto' }} alt={post?.title}/>
                </Box>
                <Article content={post?.content}/>
                <Divider my={4}/>
                <ShareSocials />
            </Section>
        </>);
}
Page.getLayout = (page, props) => (<DefaultLayout {...props}>{page}</DefaultLayout>);
async function getStaticProps(ctx) {
    const client = getApolloClient();
    const postResponse = await getPostBySlug(client, ctx.params.slug);
    return getNextStaticProps(ctx, {
        Page,
        client,
        revalidate: 60,
        props: {
            post: postResponse.data
        }
    });
}
export async function getStaticPaths() {
    return {
        paths: [],
        fallback: 'blocking'
    };
}

    async function __Next_Translate__getStaticProps__193bbee827d__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/[year]/[month]/[day]/[slug]',
            loaderName: 'getStaticProps',
            loadLocaleFrom: typeof __i18nConfig.loadLocaleFrom === 'function' ? __i18nConfig.loadLocaleFrom : (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__193bbee827d__ as getStaticProps }
  